var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2 9.14258C2 8.03801 2.89543 7.14258 4 7.14258H30C31.1046 7.14258 32 8.03801 32 9.14258V13.3688C32 14.252 31.4207 15.0306 30.5747 15.2844L18.1494 19.012C17.3996 19.2369 16.6004 19.2369 15.8506 19.012L3.42531 15.2844C2.57934 15.0306 2 14.252 2 13.3688V9.14258Z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14.8575L17 12.2861",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25024 14.8574L3.25024 25.0002C3.25024 27.2093 5.0411 29.0002 7.25024 29.0002H26.7502C28.9594 29.0002 30.7502 27.2093 30.7502 25.0002V14.8574",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 7.14283V4C22 2.89543 21.1046 2 20 2H14C12.8954 2 12 2.89543 12 4L12 7.14283",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.22039ebf2ecf40e5ca9a362402ce70d3.svg";
export { ForwardRef as ReactComponent };